import React from 'react';
import { FadeIn } from './FadeIn';
import { Check, Star } from 'lucide-react';
import { motion } from 'framer-motion';
export function PricingCards() {
  return <section className="py-6 md:py-10 px-4 max-w-5xl mx-auto" id="pricing" data-id="element-284">
      <FadeIn data-id="element-285">
        <h2 className="text-2xl md:text-4xl font-black text-center mb-5 md:mb-8 tracking-tight text-[#0f172a]" data-id="element-286">
          ELEGÍ TU SISTEMA
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-4xl mx-auto items-stretch" data-id="element-287">
        {/* Card 1 */}
        <FadeIn delay={0.1} data-id="element-288">
          <div className="bg-white border border-[#e2e8f0] rounded-2xl p-5 md:p-7 h-full flex flex-col relative hover:border-[#22c55e]/50 transition-colors shadow-sm" data-id="element-289">
            <div className="mb-3" data-id="element-290">
              <h3 className="text-lg md:text-xl font-black text-[#0f172a] flex items-center gap-2 mb-1" data-id="element-291">
                <span className="text-xl md:text-2xl" data-id="element-292">📘</span> SISTEMA
                ESCAPISTA PRO
              </h3>
              <p className="text-[#475569] font-bold text-xs md:text-sm" data-id="element-293">
                6 Tomos + 6 Bonos
              </p>
            </div>

            <div className="mb-4 pb-4 border-b border-[#e2e8f0]" data-id="element-294">
              <div className="text-[#ef4444] line-through text-sm font-bold" data-id="element-295">
                $200.000
              </div>
              <div className="text-3xl md:text-4xl font-black text-[#0f172a] flex items-baseline gap-2" data-id="element-296">
                $19.990{' '}
                <span className="text-base text-[#475569] font-bold" data-id="element-297">ARS</span>
              </div>
            </div>

            <ul className="space-y-2 mb-5 flex-grow" data-id="element-298">
              {['6 Tomos completos del sistema', '6 Bonos siempre incluidos', 'Acceso inmediato por correo', 'Más de 400 páginas de contenido aplicable', 'Adaptado al contexto argentino actual'].map((item, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-299">
                  <div className="bg-[#22c55e]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-300">
                    <Check className="text-[#16a34a]" size={14} strokeWidth={3} data-id="element-301" />
                  </div>
                  <span className="text-sm text-[#0f172a] font-bold" data-id="element-302">
                    {item}
                  </span>
                </li>)}
            </ul>

            <a href="https://tumanualdigital.com/cart/44209846878244:1" className="w-full block text-center py-3 px-4 rounded-xl font-black text-base bg-[#020617] hover:bg-[#0f172a] text-[#22c55e] transition-colors border border-[#0f172a]" data-id="element-303">
              → QUIERO MI SISTEMA ESCAPISTA PRO
            </a>
          </div>
        </FadeIn>

        {/* Card 2 - Featured */}
        <FadeIn delay={0.2} data-id="element-304">
          <div className="relative h-full" data-id="element-305">
            <div className="absolute inset-0 bg-[#C9A84C]/20 blur-3xl rounded-[3rem] animate-pulse" data-id="element-306"></div>
            <div className="bg-white border-2 border-[#C9A84C] rounded-2xl p-5 md:p-7 h-full flex flex-col relative shadow-[0_20px_50px_rgba(201,168,76,0.15)] z-10" data-id="element-307">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-gradient-to-r from-[#C9A84C] to-[#b8924a] text-[#020617] font-black px-4 py-1 rounded-full text-xs flex items-center gap-1.5 whitespace-nowrap shadow-md" data-id="element-308">
                <Star className="w-3.5 h-3.5" fill="currentColor" data-id="element-309" /> MÁS ELEGIDO
              </div>

              <div className="mb-3 mt-3" data-id="element-310">
                <h3 className="text-lg md:text-xl font-black text-[#0f172a] flex items-center gap-2 mb-1" data-id="element-311">
                  <span className="text-2xl" data-id="element-312">🏆</span> SISTEMA ESCAPISTA PRO +
                  EL ACELERADOR ESTRATÉGICO
                </h3>
                <p className="text-[#b8924a] font-bold text-xs md:text-sm" data-id="element-313">
                  6 Tomos + 6 Bonos + Toolkit de Automatización y Escalada
                </p>
              </div>

              <div className="mb-4 pb-4 border-b border-[#e2e8f0]" data-id="element-314">
                <div className="text-[#ef4444] line-through text-sm font-bold" data-id="element-315">
                  $280.000
                </div>
                <div className="text-3xl md:text-4xl font-black text-[#0f172a] flex items-baseline gap-2" data-id="element-316">
                  $27.990{' '}
                  <span className="text-base text-[#475569] font-bold" data-id="element-317">
                    ARS
                  </span>
                </div>
              </div>

              <ul className="space-y-2 mb-5 flex-grow" data-id="element-318">
                <li className="flex items-start gap-2.5" data-id="element-319">
                  <div className="bg-[#C9A84C]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-320">
                    <Check className="text-[#b8924a]" size={14} strokeWidth={3} data-id="element-321" />
                  </div>
                  <span className="text-sm text-[#0f172a] font-bold" data-id="element-322">
                    Todo lo del Sistema Escapista Pro
                  </span>
                </li>
                <li className="flex items-start gap-2.5 bg-[#C9A84C]/10 p-2 rounded-xl border border-[#C9A84C]/30 -mx-1" data-id="element-323">
                  <div className="bg-[#C9A84C] p-1 rounded-full shrink-0 mt-0.5" data-id="element-324">
                    <Check className="text-[#020617]" size={14} strokeWidth={4} data-id="element-325" />
                  </div>
                  <span className="text-sm text-[#b8924a] font-black" data-id="element-326">
                    Módulo de Automatización Extrema — De 60 min a 8 min de
                    gestión diaria
                  </span>
                </li>
                {['Ingeniería de Precios Personal — Renegociá todo lo que pagás', 'Máquina de USD Avanzada — Escalá a retenciones en dólares', 'Radar del Escalador — Detectá oportunidades en cada devaluación', 'Master Sheet Pro — Planilla automatizada con gráficos y KPIs', 'Negociador Argento — 8 guiones de negociación listos para usar', 'Escalador de Fiverr — Optimización completa para cobrar en USD'].map((item, i) => <li key={i} className="flex items-start gap-2.5" data-id="element-327">
                    <div className="bg-[#C9A84C]/20 p-1 rounded-full shrink-0 mt-0.5" data-id="element-328">
                      <Check className="text-[#b8924a]" size={14} strokeWidth={3} data-id="element-329" />
                    </div>
                    <span className="text-sm text-[#0f172a] font-bold" data-id="element-330">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <motion.a whileHover={{
              scale: 1.03
            }} whileTap={{
              scale: 0.97
            }} href="https://tumanualdigital.com/cart/44209847009316:1" className="w-full block text-center py-3 px-4 rounded-xl font-black text-base bg-[#C9A84C] hover:bg-[#b8924a] text-[#020617] transition-colors shadow-[0_10px_30px_rgba(201,168,76,0.3)]" data-id="element-331">
                → QUIERO EL SISTEMA + EL ACELERADOR
              </motion.a>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}